<label data-test="a8QZDB7J" class="radio">
  <ng-content></ng-content>
  <span data-test="pDn9LCPe" class="radio__label">{{ label }}</span>
  <span data-test="UDxlvJBc" class="radio__marker">
    <span data-test="JnCqzLed" class="radio__marker-icon"></span>
  </span>
</label>
